<script>
  import { createClient } from "@supabase/supabase-js";
  import { commentsData } from "../stores.js";
  import { generateFromString } from "generate-avatar";

  export let hostURL;
  export let postPath;
  export let supabaseUrl;
  export let anonKey;
  export const supabase = createClient(supabaseUrl, anonKey);

  let loading = true;
  let name;
  let email;
  let comment;
  let success = false;

  const getComments = async () => {
    const { data, error } = await supabase
      .from("comments")
      .select()
      .order("created_at", { ascending: false })
      .filter("postURL", "in", `(${postPath})`)
      .filter("show", "is", true);

    commentsData.set(data);

    if (data) {
      loading = false;
    }

    if (error) {
      console.log(error);
    }
  };

  const checkAndInsert = async () => {
    if (name && comment) {
      const { data, error } = await supabase.from("comments").insert({
        postURL: postPath,
        name: name,
        email: email,
        comment: comment,
        show: true,
      });

      await sendToTelegram(name, email, comment, postPath);

      if (data) {
        success = true;
        name = "";
        email = "";
        comment = "";
        getComments();
      }

      if (error) {
        console.log(error);
      }
    } else {
      alert("请填写完整信息");
    }
  };

  async function sendToTelegram(name, email, comment, postPath) {
    fetch("/api/sendtotg", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name,
        email: email,
        comment: comment,
        url: hostURL + postPath,
      })
    });
  }

  function formatDate(date, local) {
    const d = new Date(date);
    const options = { year: "numeric", month: "short", day: "numeric" };
    const res = d.toLocaleDateString(local, options);
    return local === "zh"
      ? res.replace("年", " 年 ").replace("月", " 月 ").replace("日", " 日")
      : res;
  }

  getComments();
</script>

<div>
  <!-- Create a comment box with name, email and comment textarea with tailwindcss -->
  <div class="max-w-screen-md grid sm:grid-cols-2 gap-4 mx-auto">
    <div>
      <input
        name="name"
        id="name"
        type="text"
        required
        bind:value={name}
        placeholder="你的昵称"
        class="appearance-none block w-full bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg py-3 px-4 leading-tight focus:outline-none focus:bg-white"
      />
    </div>
    <div>
      <input
        name="email"
        id="mail"
        type="text"
        required
        bind:value={email}
        placeholder="你的邮箱(可选)*"
        class="appearance-none block w-full bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg py-3 px-4 leading-tight focus:outline-none focus:bg-white"
      />
    </div>
    <div class="sm:col-span-2">
      <textarea
        name="comment"
        id="comment"
        type="text"
        required
        bind:value={comment}
        placeholder="评论内容"
        class="h-44 appearance-none block w-full bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg py-3 px-4 leading-tight focus:outline-none focus:bg-white"
      />
    </div>
    <div class="sm:col-span-2 flex justify-between items-center">
      <button
        on:click={() => {
          checkAndInsert();
        }}
        class="inline-block bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-center rounded-lg outline-none transition duration-100 px-8 py-3"
      >
        <p class="text-gray-400 h-5">提交</p>
      </button>
      <p class="mb-2 text-gray-400 text-xs">
        *如需回复, 请填写邮箱或其他有效联系方式.
      </p>
    </div>
  </div>

  <div class="mx-auto max-w-screen-md">
    <div class="mt-10 space-y-4">
      {#if loading}
        <div class="w-full">
          <div class="animate-pulse flex space-x-4">
            <div class="rounded-full bg-gray-400 h-10 w-10" />
            <div class="flex-1 space-y-4">
              <div class="h-2 w-20 bg-gray-400 rounded" />
              <div class="space-y-4">
                <div class="grid grid-cols-3 gap-4">
                  <div class="h-2 bg-gray-400 rounded col-span-1" />
                  <div class="h-2 bg-gray-400 rounded col-span-2" />
                </div>
                <div class="h-2 bg-gray-400 rounded" />
              </div>
            </div>
          </div>
        </div>
      {/if}
      {#each $commentsData as comment}
        <div class="flex">
          <div class="flex-shrink-0 mr-3">
            <img
              alt="avatar"
              class="mt-2 rounded-full w-8 h-8 sm:w-10 sm:h-10"
              src={`data:image/svg+xml;utf8,${generateFromString(
                comment.email || comment.name
              )}`}
            />
          </div>
          <div
            class="w-full bg-gray-100 dark:bg-gray-700 rounded-lg px-4 py-2 sm:px-6 sm:py-4 leading-relaxed"
          >
            <strong>{comment.name}</strong>
            <span class="text-xs text-gray-400"
              >{formatDate(comment.created_at, "zh")}</span
            >
            <p class="text-sm">
              {comment.comment}
            </p>
          </div>
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
</style>
